let reloading = false;

/** Full-page reload the app starts itself (session expired); unload guards must let it through. */
export const reloadApp = (): void => {
  reloading = true;
  window.location.href = '';
};

export const isAppReloading = (): boolean => reloading;
